import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type DialogHeaderContext = {
    ids: any[];
    changeSearchUrl: string,
    newSearchUrl: string;
    index?: number;
}

@Injectable({providedIn: 'root'})
export class HisDialogHeaderPaginatorService {

    private data$ = new BehaviorSubject<DialogHeaderContext>( {
        ids: [],
        changeSearchUrl: '',
        newSearchUrl: '',
        index: 0
    } );

    publishData( data: DialogHeaderContext ) {
        this.data$.next( data );
    }

    getData() {
        return this.data$.asObservable();
    }

    clear() {
        this.data$.next( {
            ids: [],
            changeSearchUrl: '',
            newSearchUrl: '',
            index: 0
        } );
    }
}